import {Placements} from "./../../../wui-core/src/types/iCore";

export const BUILT_IN_PLACEMENTS: Placements = {
    bottomLeft: {
        points: ['tl', 'bl'],
        offset: [0, 4],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: ['tr', 'br'],
        offset: [0, 4],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: ['bl', 'tl'],
        offset: [0, -4],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: ['br', 'tr'],
        offset: [0, -4],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
}

export const getPlacement = (props: any) => {
    // placement更新为dropdownAlign
    const {dropdownAlign, placement = 'bottomLeft'} = props
    return BUILT_IN_PLACEMENTS[dropdownAlign || placement]
}
